import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";


interface Props {
  onTapCloseModal: () => void;
}


export const SendShareMailModal = ({ onTapCloseModal }: Props) => {

  return (
    <BasePageModal
      title="データ共有"
      className="md-user-mail"
      handleClose={() => {
        onTapCloseModal();
      }}
      bottomChildren={
        <BaseRoundButton
          buttonText="閉じる"
          onClick={onTapCloseModal}
        />
      }
    >
      <h2>
        招待メールを送信しました
      </h2>
    </BasePageModal>
  );
};
